import React from 'react';
import classNames from 'classnames/bind';
import { enhancedConnect } from "../../../utils";
import styles from "../styles.pcss";
var cx = classNames.bind(styles);
export var _CarouselSlideBanner = function _CarouselSlideBanner(_ref) {
  var href = _ref.href,
    children = _ref.children,
    ariaLabel = _ref.ariaLabel,
    isBlankUrlTarget = _ref.isBlankUrlTarget,
    title = _ref.title,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'default' : _ref$type;
  return /*#__PURE__*/React.createElement("a", {
    "aria-label": ariaLabel,
    className: cx('carousel-slide-banner', type),
    href: href,
    rel: "noreferrer",
    target: isBlankUrlTarget ? '_blank' : '_self',
    title: title,
    "data-t-id": "Carousel-CarouselSlideBanner"
  }, children);
};
export var CarouselSlideBanner = enhancedConnect()(_CarouselSlideBanner);